import { COMPETENCES_PAR_MATIERE } from './evalPapier';

// Nom de compétence → id (maths et français), la table de evalPapier.
const ID_PAR_COMPETENCE = new Map(
    Object.values(COMPETENCES_PAR_MATIERE).flat().map((c) => [c.nom, c.id]),
);

/** L'id d'une compétence d'après son nom, null si inconnu. */
export const idCompetence = (nom) => ID_PAR_COMPETENCE.get(nom) ?? null;

/**
 * Les exercices du POST evaluations/ depuis les choix de l'assistant « J'ai
 * déjà mon sujet » (selectedComps : [{ savoir, competences, type }], type
 * 'attendu' ou 'savoir'). Chaque entrée garde l'attendu (ou le savoir-faire)
 * coché, AVEC son id : on le prend tel quel (2026-09-29). Avant, l'id était
 * retrouvé par le libellé dans l'arbre chargé : un attendu d'un autre niveau
 * que la classe n'y était pas (l'envoi plantait), et deux attendus au même
 * libellé pouvaient être confondus.
 */
export const exercicesDepuisSelection = (selectedComps) => (selectedComps || []).map(
    ({ savoir, competences, type }) => ({
        titre: 'Exercice',
        comp_ids: (competences || []).map(idCompetence),
        ...(type === 'attendu' ? { attendu_id: savoir.id } : { savoir_faire_id: savoir.id }),
    }),
);
